import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import axios from "axios";
import router from './router'
import store from './store'
import require from 'require.js'

import $ from 'jquery'
window.$ = window.jQuery = $
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-table/dist/bootstrap-table.min.css'
// import 'bootstrap-table/dist/bootstrap-table-vue.min.js'

// import 'bootstrap-table/dist/bootstrap-table.js'
// import 'bootstrap-table/dist/locale/bootstrap-table-zh-CN.min.js'

import '@/styles/index.css'//全局样式
Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/api'
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
